import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/sharp-solid-svg-icons';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { twMerge } from 'tailwind-merge';

import Divider from '@/components/divider';
import Typography from '@/components/typography';
import { RootState } from '@/redux/store';

import CreateLeadListButton from './selectionsPanelContent/customAccordianContent/createLeadListButton';

type Props = {
  onToggle: () => void;
  isOpen: boolean;
};

export const SelectionsDropDownButton: FC<Props> = ({ onToggle, isOpen }) => {
  const allFeatures = useSelector(
    (state: RootState) => state.features.allFeatures
  );

  const totalSelections = useMemo(() => {
    return allFeatures.length;
  }, [allFeatures.length]);

  return (
    <div
      aria-pressed={false}
      className={twMerge('flex h-[40px] w-full items-center bg-gray-10')}
      role="button"
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onToggle();
        }
      }}
    >
      <Typography className="flex flex-row items-center pl-2" variant="h5">
        Selections
        <div className="mx-2">
          <Divider
            isVertical
            className="mx-1 my-auto h-[14px] !w-[1px] bg-gray-20"
          />
        </div>
        {totalSelections}
      </Typography>
      <div className="ml-auto flex h-full flex-row flex-nowrap">
        <CreateLeadListButton
          className={twMerge(
            'flex h-10 w-10 items-center justify-center p-0',
            'text-gray-100 hover:bg-gray-40'
          )}
        />
        <span className="flex h-full w-[40px] items-center justify-center hover:bg-gray-40">
          <FontAwesomeIcon
            className={twMerge(
              'h-4 w-4',
              isOpen ? ' rotate-0' : 'rotate-180',
              'text-gray-70 transition-transform duration-300'
            )}
            icon={faChevronUp}
          />
        </span>
      </div>
    </div>
  );
};
